<div [ngClass]="{'row':true, 'row_main': step != 2}">

  <!--detalle simulación-->
  @if(step == 1){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

      <div style="margin-top: 30px;">
        <div class="titulo-card" style="margin-bottom: 10px;">¡revisa la simulación de tu primera operación en Simpli!
        </div>

        <div class="label-container" style="text-align: center;">
          Las facturas que elegimos están <span (click)="open_modal_info(10)">preaprobadas</span> para una operación
          inmediata.
        </div>
      </div>



    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">


      <mat-card class="centerabsolute" style="max-width: 600px;margin-top: 20px;">

        <mat-card-content>

          <div class="box-info-onboarding">
            <div class="icon"><span class="material-symbols-outlined">info</span></div>
            <div>La apertura de la línea de factoring tiene un costo aproximado de $98.500, que se descontará de la
              primera operación.
            </div>
          </div>

          <div class="box-info-facturas">
            <div class="titulo-facturas">Facturas de la simulación</div>

            <div class="container-facturas add_factoring">

              <div class="row" style="margin-bottom: 5px;">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Cantidad de facturas:</div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="font-weight: bold;text-align: right;">
                  @if(loading_cantidad){
                    <skeleton-loader></skeleton-loader>
                    }@else{
                    {{cantidad_facturas_original}}
                  }
                </div>

              </div>

              <div>
                <div style="text-align: right;">
                  <mat-label class="pink-label" (click)="detalle_factura()">Abrir detalle <span class="material-symbols-outlined">chevron_right</span></mat-label>
                </div>
              </div>

            </div>
          </div>

          <div class="box-info-facturas">
            <div class="titulo-facturas">Montos asociados</div>

            <div>
              <div class="row row-montos">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total simulado:</div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                  @if(loading){
                    <skeleton-loader></skeleton-loader>
                    }@else{
                    ${{settings.formatMoney(monto_simulado)}}
                  }
                </div>
              </div>
              <div class="row row-montos">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Porcentaje de financiamiento:</div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                  @if(loading){
                    <skeleton-loader></skeleton-loader>
                    }@else{
                    {{porcentaje_financiamiento}}%
                  }
                </div>
              </div>
              <div class="row row-montos">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto de anticipo:</div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                  @if(loading){
                    <skeleton-loader></skeleton-loader>
                    }@else{
                    ${{settings.formatMoney(monto_anticipo)}}
                  }
                </div>
              </div>
              <div class="row row-montos">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Vencimiento:</div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                  @if(loading){
                    <skeleton-loader></skeleton-loader>
                    }@else{
                    {{dias_promedio}} días
                  }
                </div>
              </div>

              @if(expandir) {
                <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Tasa de interés:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      {{tasa_interes}}%
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total de interés:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(interes_total)}}
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Comisión:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(comision)}}
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Gastos operacionales:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(gastos)}}
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn" style="display: none;">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Diferencia de precios:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(interes_total)}}
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">IVA:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(iva_operacion)}}
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Excedentes:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(excedentes)}}
                    }
                  </div>
                </div>

                <div class="row row-montos animate__animated  animate__faster animate__fadeIn" style="display: none;">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Costo de apertura:</div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                    @if(loading){
                      <skeleton-loader></skeleton-loader>
                      }@else{
                      ${{settings.formatMoney(98500)}}
                    }
                  </div>
                </div>
              }



              <div (click)="expandir = !expandir"
                style="display: flex;justify-content: center;align-items: center;gap: 10px;color: gray;font-size: 13px;cursor: pointer;">
                @if(expandir){
                  contraer
                  }@else{
                  expandir
                }
                @if (expandir == false) {
                  <span>
                    <span class="material-symbols-outlined" style="font-size: 16px;">expand_more</span>
                  </span>
                }
                @if (expandir == true) {
                  <span>
                    <span class="material-symbols-outlined" style="font-size: 16px;">expand_less</span>
                  </span>
                }

              </div>


            </div>

          </div>

          <div class="box-info-facturas">

            <div>

              <div class="row row-montos">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 titulo-facturas" style="margin-bottom: 0px;">Monto total a
                girar:</div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  style="text-align: right;font-weight: bold;font-size: 24px;">
                  @if(loading){
                    <skeleton-loader></skeleton-loader>
                    }@else{
                    ${{settings.formatMoney(monto_recibir)}}
                  }
                </div>
              </div>
            </div>

          </div>

          <div class="contact-container" style="margin-top: 10px;">
            <div class="icons">
              <span (click)="step = 3"><span class="material-symbols-outlined">edit</span>Editar simulación</span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              @if(loading_pdf_ == false){
                <span (click)="download_pdf()"><span class="material-symbols-outlined">download</span>Descargar simulación</span>
                }@else{
                <span style="opacity: 0.5;"><span class="material-symbols-outlined mat-spin">progress_activity</span> Descagar simulación</span>
              }

            </div>
          </div>

          <!-- <div class="caja-botones mt-20">
          <button mat-stroked-button class="primary-button" (click)="step = 8; put_step(7)">Continuar</button>
        </div> -->

        <div class="caja-botones mt-20">
          <button mat-stroked-button class="primary-button" (click)="step = 2;">Continuar</button>
        </div>


      </mat-card-content>

    </mat-card>



  </div>
}


<!--simulacion ok-->
@if(step == 2){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <mat-card class="centerabsolute2" style="max-width: 700px;">
      <div class="titulo-card">
        Solo falta que formalices tu incorporación como cliente
      </div>
      <mat-card-content>
        <div class="container-final" style="flex-direction: column;">
          <div class="imagen-final">
            <img src="../../assets/iconografia/formalizar.png" style="height: 160px !important;">
          </div>
          <div class="container-titulos" style="margin-top: 20px;">
            <div class="label-container">
              Para avanzar con el financiamiento de tu operación, <strong>debes firmar algunos documentos.</strong>
              <br><br>
              En breve, <strong>{{name}} te contactará </strong><br>para guiarte en este proceso.
            </div>
          </div>

          <div class="caja-botones docs-faltantes">
            <button mat-stroked-button class="secondary-button secondary-responsive" (click)="volverASimulacion()">
              Volver a revisar simulación
            </button>
            <button mat-stroked-button class="primary-button" (click)="navigateToHome()">Ir al inicio de la
            plataforma</button>
          </div>

          @if (pendingDocs > 3) {
            <span>
              <contact-container [tittle]="'Prefiero contactar a un ejecutivo.'"></contact-container>
            </span>
          }


        </div>
      </mat-card-content>
    </mat-card>
  </div>
}


<!-- dialog estado situacion financiera -->
@if(step == 5){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <mat-card class="centerabsolute2" style="max-width: 700px;">



      <!-- Seleccion inicial -->
      @if(situacionFinancieraView === 1) {
        <div style="position: relative;margin-top: 10px;">
          <div class="volver-dialog" (click)="stepper_cuentas = 2; step = 4">
            <span class="material-symbols-outlined">chevron_left</span>
            <span>Volver</span>
          </div>
        </div>


        <div class="imagen-final" style="padding-top: 20px !important;">
          <img src="../../assets/iconografia/iconografia - web analysis.png" style="height: 160px !important;">
        </div>
        <mat-card-content>
          <div class="container-final" style="flex-direction: column;">
            <div class="titulo-card situacion-fin">¿Cuentas con un Estado de situación utilizado dentro de los <br>últimos
              6 meses en otra
              entidad?
            </div>
            <div class="caja-botones-situacion-fin">
              <button mat-stroked-button class="secondary-button" (click)="dialogSituacionFinanciera()">No</button>
              <button mat-stroked-button class="primary-button" (click)="situacionFinancieraView = 2">Sí</button>
            </div>
          </div>
        </mat-card-content>
      }

      @if(situacionFinancieraView === 2) {
        <div style="position: relative;margin-top: 10px;;">
          <div class="volver-dialog" (click)="step = 5; situacionFinancieraView = 1">
            <span class="material-symbols-outlined">chevron_left</span>
            <span>Volver</span>
          </div>
        </div>

        <div class="imagen-final" style="padding-top: 20px !important;">
          <img src="../../assets/iconografia/iconografia - web analysis.png" style="height: 160px !important;">
        </div>
        <mat-card-content>
          <div class="container-final" style="flex-direction: column;">
            <div class="titulo-card situacion-fin">carga tu Estado de situación financiera</div>
            <div class="subtitulo-onboarding">También puedes completar el documento en línea.</div>
            <div class="caja-botones-situacion-fin">
              <button mat-stroked-button class="secondary-button" (click)="dialogSituacionFinanciera()">Completar
              documento</button>
              <button mat-stroked-button class="primary-button" (click)="situacionFinancieraView = 3">Cargar
              documento</button>
            </div>
          </div>
        </mat-card-content>
      }

      @if(situacionFinancieraView === 3) {
        <div style="position: relative;margin-top: 10px;">
          <div class="volver-dialog" (click)="clearSelectedFile(); step = 5; situacionFinancieraView = 2">
            <span class="material-symbols-outlined">chevron_left</span>
            <span>Volver</span>
          </div>
        </div>

        <div class="imagen-final" style="padding-top: 20px !important;">
          <img src="../../assets/iconografia/Iconografia - Upload file.png" style="height: 160px !important;">
        </div>
        <mat-card-content>
          <div class="container-final" style="flex-direction: column;">
            @if (!isFileSelected) {
              <div class="titulo-card situacion-fin">agrega el archivo desde tu equipo o dispositivo
              </div>
            }
            @if (isFileSelected) {
              <div class="titulo-card situacion-fin">¡Archivo agregado!</div>
            }
            @if (isFileSelected) {
              <div class="subtitulo-onboarding">Ya puedes cargar el documento.</div>
            }
            @if (isFileSelected) {
              <div class="name-file-container" (click)="fileInput.click()">
                <input class="no-input select-name" [value]="selectedFileName" readonly>
                <span class="material-symbols-outlined" style="color: var(--green);">check</span>
              </div>
            }


            <input #fileInput type="file" accept=".pdf,.jpg,.jpeg" style="display: none;"
              (change)="onFileSelected($event)">

            @if (!isFileSelected) {
              <div class="agregar-archivo" (click)="fileInput.click()">
                <div class="icon-agregar">
                  <span class="material-symbols-outlined">add_circle</span>
                </div>
                <div class="text-agregar">
                  <div class="titulo2">Agregar archivo</div>
                  <div class="subtitulo2">Solo se admite el formato PDF o JPG y un peso máximo de “50 MB” por archivo.</div>
                </div>
              </div>
            }

            @if (isFileSelected) {
              <div class="agregar-archivo" (click)="fileInput.click()">
              </div>
            }


            <div class="caja-botones-situacion-fin">
              <button mat-stroked-button class="primary-button" [disabled]="!isFileSelected" (click)="uploadDocument()">
                Cargar documento
              </button>
            </div>
          </div>
        </mat-card-content>
      }

      @if(situacionFinancieraView === 4) {
        @if (isLoading) {
          <div>
            <div class="imagen-final" style="padding-top: 20px !important;">
              <img src="../../assets/iconografia/Iconografia - Agency.png" style="height: 160px !important;">
            </div>
            <mat-card-content>
              <div class="container-final" style="flex-direction: column;">
                <div class="titulo-card situacion-fin">estamos procesando la información. <br>esto no tomará mucho tiempo
                </div>
                <loading-interno />
              </div>
            </mat-card-content>
          </div>
        }

        @if (!isLoading) {
          <div>
            <div style="position: relative;margin-top: 10px;">
              <div class="volver-dialog" (click)="step = 5; situacionFinancieraView = 3">
                <span class="material-symbols-outlined">chevron_left</span>
                <span>Volver</span>
              </div>
            </div>
            <mat-card-content>
              <div class="container-final" style="flex-direction: column;">
                <div class="titulo-card situacion-fin">confirma los datos del Estado de situación cargado</div>
                <div class="subtitulo-onboarding">Si lo necesitas, puedes reemplazar el documento.</div>
                <div class="caja-botones-situacion-fin">
                  <button mat-stroked-button class="secondary-button">Confirmar datos</button>
                  <button mat-stroked-button class="primary-button" (click)="situacionFinancieraView = 3">Reemplazar
                  documento</button>
                </div>
              </div>
            </mat-card-content>
          </div>
        }
      }

    </mat-card>
  </div>
}

<!--editar simulacion-->
@if(step == 3){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">


    <div style="margin-top: 30px;">
      <div class="titulo-card" style="margin-bottom: 10px;">¡revisa las facturas que seleccionamos para tu simulación!
      </div>
      <div class="label-container" style="text-align: center;">
        Las siguientes facturas <strong>fueron evaluadas</strong> y ya cuentan con nuestra <span
      (click)="open_modal_info(10)">preaprobación</span>.
    </div>
  </div>



</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">

      <div style="display: flex;align-items: center;">
        <mat-form-field appearance="fill" style="width: 400px;">
          <mat-label>Buscar</mat-label>
          <input matInput [formControl]="buscar" (change)="applyFilter()">
          <mat-icon matSuffix class="icon-suffix">search</mat-icon>
        </mat-form-field>

        <button style="margin-left: 20px;" (click)="open_modal_info(11, false)" mat-stroked-button
        class="secondary-button">Agregar más facturas</button>
      </div>

    </div>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

  <div class="row">

    @if(facturas.length > 0 && loading_facturas == false){
      <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12" style="margin: 0 auto;">
        <div class="label-table">Puedes eliminar o agregar más facturas antes de operar.</div>

        <mat-card class="card-tabla">
          <mat-card-content>
            <div class="table-responsive-simpli add_factoring">

              <table mat-table [dataSource]="dataSource">


                <ng-container matColumnDef="deudor">
                  <th mat-header-cell *matHeaderCellDef>Deudor</th>
                  <td mat-cell *matCellDef="let element">
                    <input readonly class="no-input" value="{{element.document.nombre_deudor}}">
                  </td>
                </ng-container>

                <ng-container matColumnDef="factura">
                  <th mat-header-cell *matHeaderCellDef>Factura</th>
                  <td mat-cell *matCellDef="let element">
                    <input readonly class="no-input" value="{{element.document.folio}}">
                  </td>
                </ng-container>

                <ng-container matColumnDef="rut">
                  <th mat-header-cell *matHeaderCellDef>RUT</th>
                  <td mat-cell *matCellDef="let element">
                    <input readonly class="no-input" value="{{element.document.rut_deudor}}">
                  </td>
                </ng-container>

                <ng-container matColumnDef="fecha">
                  <th mat-header-cell *matHeaderCellDef>Fecha de emisión</th>
                  <td mat-cell *matCellDef="let element">
                    <input readonly class="no-input" value="{{element.document.fecha_documento}}">
                  </td>
                </ng-container>

                <ng-container matColumnDef="monto">
                  <th mat-header-cell *matHeaderCellDef>Monto</th>
                  <td mat-cell *matCellDef="let element">
                    <input readonly class="no-input" value="${{settings.formatMoney(element.document.monto_total)}}">
                  </td>
                </ng-container>

                <ng-container matColumnDef="accion">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                    @if (!element.isLoading && cantidad_facturas > 1) {
                      <span
                        (click)="delete_factura(element.document.document_factura_id, element.document_simulacion_id)">
                        <span class="material-symbols-outlined">delete</span>
                      </span>
                    }

                    <!-- Mostrar ícono deshabilitado cuando solo hay una factura -->
                    @if (!element.isLoading && cantidad_facturas <= 1) {
                      <span style="opacity: 0.3; cursor: default;"
                        matTooltip="No puedes eliminar la única factura">
                        <span class="material-symbols-outlined">delete</span>
                      </span>
                    }

                    @if (element.isLoading) {
                      <span>
                        <span class="material-symbols-outlined mat-spin">progress_activity</span>
                      </span>
                    }
                  </td>
                </ng-container>



                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

            </div>
          </mat-card-content>
        </mat-card>

      </div>
    }

    @if(facturas.length == 0 && loading_facturas == true){
      <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12" style="margin: 0 auto;">
        <loading-interno></loading-interno>
      </div>
    }

    @if(loading_facturas == false){
      <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12" style="margin: 0 auto;">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">

          <div style="flex: 1;"></div>

          <div style="flex: none;" class="no-wrap-paginator">
            <paginador-onboarding [pageSize]="7" [totalElements]="cantidad_facturas" [currentPage]="page"
              (pageChange)="pageEvent($event)">
            </paginador-onboarding>
          </div>

          <div style="flex: 1; text-align: right;">
            @if (dataSource.data.length > 0) {
              <button mat-stroked-button class="primary-button" (click)="step = 1">
                Volver
              </button>
            }
          </div>
        </div>

      </div>
    }

    @if(facturas.length == 0 && loading_facturas == false){
      <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12" style="margin: 0 auto;margin-bottom: 20px;margin-top: 20px;">
        <no-hay-registros [text]="'No se encontraron facturas.'"></no-hay-registros>

        <button mat-stroked-button class="primary-button" (click)="step = 1" style="margin-top: 20px;float:right">
          Volver
        </button>
      </div>
    }

  </div>
</div>
}

<!-- 4 cuentas bancarias-->
@if(step == 4){

  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

    <div class="title-container" style="text-align: center;">
      <div class="titulo-card">formaliza tu incorporación como cliente</div>
    </div>


    <div class="stepper">
      <div [ngClass]="{'step': true, 'active': stepper_cuentas == 1}">
        <div class="circle">
          <span class="material-symbols-outlined">account_balance</span>
        </div>
        <div class="step-text">Cuenta <br>bancaria</div>
      </div>
      <div class="line"></div>
      <div [ngClass]="{'step': true, 'active': stepper_cuentas == 2}">
        <div class="circle">
          <span class="material-symbols-outlined">folder_open</span>
        </div>
        <div class="step-text">Documentación<br><br></div>
      </div>
      <div class="line"></div>
      <div [ngClass]="{'step': true, 'active': stepper_cuentas == 3}">
        <div class="circle">
          <span class="material-symbols-outlined">draw</span>
        </div>
        <div class="step-text">Firma<br><br></div>
      </div>
    </div>



  </div>

  <div class="col-lg-3 col-md-2 col-sm-1 col-xs-12 animate__animated animate__faster animate__fadeIn"></div>

  <!-- Registrar cuenta bancaria -->
  @if(stepper_cuentas == 1) {
    @if (isLoading) {
      <div
        class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
        <loading-interno></loading-interno>
      </div>
    }

    @if (!isLoading) {
      <div
        class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
        <mat-card class="card-simpli">
          <mat-card-content>
            @if (!hasAccounts) {
              <div class="titulo-simpli">agrega una cuenta bancaria</div>
            }
            @if (!hasAccounts) {
              <div class="texto-centrado">Registra la cuenta de tu empresa para recibir el
              financiamiento.</div>
            }
            @if (hasAccounts) {
              <div class="titulo-simpli">¡Cuenta registrada!</div>
            }
            @if (hasAccounts) {
              <div class="texto-centrado">Puedes revisar o editar los datos de la cuenta antes de
              continuar.</div>
            }
            @if (!hasAccounts) {
              <div class="container-cuenta">
                <div>Cuenta bancaria</div>
                <div class="status-cuenta"><span class="material-symbols-outlined">schedule</span> Pendiente</div>
              </div>
            }
            @if (hasAccounts) {
              <div class="container-cuenta">
                <div>{{capitalizeText(accountData.bank.name)}}</div>
                <div class="status-cuenta-listo">
                  <span class="material-symbols-outlined">check_circle</span> Registrada
                  <span (click)="editarCuentaBancaria(accountData.id); $event.stopPropagation()"><span class="material-symbols-outlined edit-icon">edit</span></span>
                </div>
              </div>
            }
            <div class="btn-container">
              <button mat-stroked-button type="button" class="secondary-button"
              (click)="volverDesdeRegistro()">Volver</button>
              @if (!hasAccounts) {
                <button mat-stroked-button type="button" class="primary-button"
                (click)="agregarCuentaBancaria()">Agregar cuenta bancaria</button>
              }
              @if (hasAccounts) {
                <button mat-stroked-button type="button" class="primary-button"
                (click)="verDocumentos()">Continuar</button>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
  }

  <!-- Documentación -->
  @if(stepper_cuentas == 2) {

    @if (isLoading) {
      <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn"
        style="margin: 0 auto;">
        <loading-interno></loading-interno>
      </div>
    }

    @if (!isLoading) {
      <div
        class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
        <mat-card class="card-simpli">
          <mat-card-content>
            <div class="titulo-simpli">{{titleText}}</div>
            <span class="subtitulo-doc">{{subtitleText}}</span>
            <div class="subtitulo-simpli-progress">Documentos completados</div>
            <div class="custom-progress-bar">
              <div class="custom-progress-bar-fill" [style.width.%]="progress"></div>
              <div class="progress-text">{{ progress }}%</div>
            </div>
            @for (section of ['Documentos legales', 'Poderes legales', 'Contrato']; track section) {
              @if (shouldShowSection(section)) {
                <div class="titulo-simpli-doc">{{section}}</div>
                @for (doc of getDocumentsBySection(section); track doc) {
                  <div class="container-cuenta-doc">
                    <div class="doc-container">
                      <div class="doc-tittle">{{document_config[doc].displayName}}</div>
                <div [ngClass]="{'status-cuenta-listo': document_config[doc].status.hasData,
                                    'status-cuenta-falta clickable': !document_config[doc].status.hasData}"
                        class="status-container"
                        (click)="!document_config[doc].status.hasData && handleDocumentClick(doc, 'view')">
                        <div class="status-text">
                          <span class="material-symbols-outlined">{{ document_config[doc].status.hasData ? 'check_circle' : 'schedule' }}</span>
                          {{ getStatusText(doc) }}
                        </div>
                        <div class="action-icons">
                          @if (document_config[doc].status.hasData) {
                            <span (click)="handleDocumentClick(doc, 'view')"
                              class="clickable">
                              <span class="material-symbols-outlined edit-icon">visibility</span>
                            </span>
                          }
                          @if (!document_config[doc].status.hasData) {
                            <span (click)="$event.stopPropagation()">
                              <span class="material-symbols-outlined edit-icon" style="cursor: default;">visibility</span>
                            </span>
                          }
                          @if (document_config[doc].status.hasData) {
                            <span (click)="handleDocumentClick(doc, 'download')"
                              class="clickable">
                              <span class="material-symbols-outlined edit-icon">south</span>
                            </span>
                          }
                          @if (!document_config[doc].status.hasData) {
                            <span (click)="$event.stopPropagation()">
                              <span class="material-symbols-outlined edit-icon" style="cursor: default;">south</span>
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            }
            <div class="btn-container">
              <button mat-stroked-button type="button" class="secondary-button"
              (click)="volverDesdeDocumentacion()">Volver</button>
              <button mat-stroked-button type="button" class="primary-button"
                (click)="stepper_cuentas = 3; clave_unica = 0">Ir a
              firmar</button>
              <!-- [disabled]="hasPendingDocuments()" -->
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
  }

  <!-- Firmar -->
  @if(stepper_cuentas == 3) {

    @if(clave_unica == 0) {
      <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
        <mat-card class="card-simpli">
          <mat-card-content>
            <div class="titulo-simpli">pasos para firmar la documentación legal</div>

            <div class="firmar-container">
              <div class="paso">
                <div class="numero">1</div>
                <div class="texto">Para comenzar, deberás <strong>ingresar tu Clave Única</strong>.</div>
              </div>
              <div class="paso">
                <div class="numero">2</div>
                <div class="texto">Para ayudarnos a validar tus datos, tendrás que <strong>ingresar el número de
                documento</strong> de tu cédula.</div>
              </div>
              <div class="paso">
                <div class="numero">3</div>
                <div class="texto">Deberás <strong>responder 4 preguntas personales</strong> de seguridad para confirmar tu
              identidad.</div>
            </div>
            <div class="paso">
              <div class="numero">4</div>
              <div class="texto">Por último, tendrás que <strong>activar la geolocalización</strong> y crear tu <span
            (click)="open_modal_info(13)">PIN personal de firma segura</span>.</div>
          </div>
        </div>


        <div class="btn-container">
          <button mat-stroked-button type="button" class="secondary-button"
          (click)="stepper_cuentas = 2; getDocumentos()">Volver</button>
          <button mat-stroked-button type="button" class="primary-button" (click)="loginClaveUnica()">Continuar</button>
        </div>

        <div class="container-info-geo">
          <span (click)="open_modal_info(14)">¿Por qué es necesario activar la geolocalización?</span>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
  } @if (clave_unica == 1) {
  <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <mat-card class="card-simpli">
      @if (!accessToken) {
        <mat-card-content>
          <loading-interno></loading-interno>
          <div class="btn-container">
            <button mat-stroked-button type="button" class="secondary-button"
            (click)="stepper_cuentas = 3; clave_unica = 0">Volver</button>
            <button mat-stroked-button type="button" class="primary-button" (click)="checkToken()">Verificar clave
            unica</button>
          </div>
        </mat-card-content>
      }

      @if (accessToken) {
        <mat-card-content>
          <div class="titulo-simpli">ingresa el número de documento de tu cédula</div>
          <div class="numeroDocumento-container">
            <img src="../../../assets/img/carnet-claveunica.png">
            <div class="texto">Encuentra el número solicitado en la cara frontal de tu cédula (mira la imagen). Este dato
            nos permitirá validar tu información personal (edad, nacionalidad, etc).</div>
          </div>
          <form [formGroup]="valFormNumeroDocumento">
            <mat-form-field>
              <mat-label>Número de documento</mat-label>
              <input type="text" formControlName="numeroDocumento" matInput required (keydown)="preventSpaces($event)" />
              <mat-hint>Ingresa el número de documento sin puntos</mat-hint>
              <mat-error>El número de documento es <strong>requerido</strong></mat-error>
            </mat-form-field>
          </form>
          <div class="btn-container">
            <button mat-stroked-button type="button" class="secondary-button"
            (click)="stepper_cuentas = 3; clave_unica = 0;">Volver</button>
            <button mat-stroked-button type="button" class="primary-button" [disabled]="!valFormNumeroDocumento.valid"
            (click)="stepper_cuentas = 3; clave_unica = 2">Continuar</button>
          </div>
        </mat-card-content>
      }
    </mat-card>

  </div>
  } @if (clave_unica == 2) {
  <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <mat-card class="card-simpli">
      @if (!accessToken) {
        <mat-card-content>
          <loading-interno></loading-interno>
          <div class="btn-container">
            <button mat-stroked-button type="button" class="secondary-button"
            (click)="stepper_cuentas = 3; clave_unica = 1">Volver</button>
          </div>
        </mat-card-content>
      }

      @if (accessToken) {
        <mat-card-content>
          <div class="titulo-simpli">responde las 4 preguntas personales para confirmar tu identidad</div>
          <div class="numeroDocumento-container">
            <span class="material-symbols-outlined" style="color: #5B61EF;">info</span>
            <div class="texto">Debes responder al menos <strong>3 preguntas correctamente</strong>. Tienes 3 intentos para
          lograrlo. Si se agotan, podrás volver a intentarlo en 24 horas.</div>
        </div>
        <div class="preguntas-container" style="padding-top: 10px;">
          <div class="titulo-simpli-doc">{{ questionData.preguntas[currentQuestion].descripcion }}</div>
          <mat-radio-group [(ngModel)]="selectedRadioValue">
            @for (alternativa of questionData.preguntas[currentQuestion].alternativas; track alternativa) {
              <div class="container-cuenta-doc"
                [ngClass]="{'selected-container': selectedRadioValue === parseInt(alternativa.id)}">
                <div class="doc-container">
                  <div class="doc-tittle">
                    <mat-radio-button class="example-radio-button" [value]="parseInt(alternativa.id)"
                      (change)="onRadioChange(questionData.preguntas[currentQuestion].id, alternativa.id)">
                      {{ capitalizeTextQuestion(alternativa.descripcion) }}
                    </mat-radio-button>
                  </div>
                </div>
              </div>
            }
          </mat-radio-group>
          <div class="progress-container">
            @for (pregunta of questionData.preguntas; track pregunta; let i = $index) {
              <div class="progress-step"
                [ngClass]="{'active-step': i < currentQuestion || (i === currentQuestion && selectedAnswers[pregunta.id])}">
              </div>
            }
          </div>
          <p>Pregunta {{ currentQuestion + 1 }} de {{ questionData.preguntas.length }}</p>
        </div>
        <div class="btn-container">
          <button mat-stroked-button type="button" class="secondary-button" (click)="previousQuestion()">Volver</button>
          <button mat-stroked-button type="button" class="primary-button" [disabled]="!isAnswerSelected()"
            (click)="nextQuestion()">
          {{ currentQuestion < questionData.preguntas.length - 1 ? 'Siguiente' : 'Continuar' }} </button>
        </div>
      </mat-card-content>
    }
  </mat-card>

</div>
} @if (clave_unica == 3) {
<div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
  <mat-card class="card-simpli">
    <mat-card-content>
      <div class="titulo-simpli">activa la geolocalización antes de firmar</div>

      <div class="imagen-final" style="padding-top: 20px !important;">
        <img src="../../assets/iconografia/Iconografia - geolocalizacion.png" style="height: 160px !important;">
      </div>

      <div class="numeroDocumento-container">
        <div class="texto" style="text-align: center !important;">La notaría necesita verificar tu ubicación para
          validar la firma electrónica. Una vez que firmes los documentos, la geolocalización <strong>se desactivará
        de forma automática</strong>.</div>
      </div>

      <div class="preguntas-container" style="padding-top: 10px;">
        <div style="display: flex; align-items: center; justify-content: center;">
          <mat-slide-toggle [(ngModel)]="isGeolocationEnabled" (change)="onGeolocationToggle($event)">
            Activar geolocalización
          </mat-slide-toggle>
        </div>
      </div>



      <div class="btn-container">
        <button mat-stroked-button type="button" class="secondary-button"
        (click)="stepper_cuentas = 3; clave_unica = 2;">Volver</button>
        <button mat-stroked-button type="button" class="primary-button" [disabled]="!isGeolocationEnabled"
          (click)="stepper_cuentas = 3; clave_unica = 4;">
          Continuar
        </button>
      </div>



    </mat-card-content>
  </mat-card>

</div>
} @if (clave_unica == 4) {
<div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
  <mat-card class="card-simpli">
    <mat-card-content>
      <div class="titulo-simpli">crea tu&nbsp;<span style="text-transform: uppercase;">PIN</span>&nbsp;personal de
    firma segura</div>

    <div class="numeroDocumento">
      <div class="texto"><strong>Protege tu firma electrónica</strong> con tu PIN personal. Una vez creado, podrás
    firmar la documentación legal de forma segura.</div> <br>
    <span class="texto-lista" style="cursor: default;">Indicaciones para crear el PIN:
      <ul>
        <li>Debe contener <strong>4 dígitos</strong>.</li>
        <li>Solo se permiten números.</li>
        <li>Evita combinaciones demasiado sencillas (ejemplo: 1234 o 4321).</li>
        <li><strong>Asegúrate de recordarlo</strong> para futuros procesos de firma.</li>
      </ul>
    </span>
  </div>

  <form [formGroup]="pinForm">
    <mat-form-field class="custom-mat-field">
      <mat-label>PIN de firma</mat-label>
      <input matInput [type]="showPin ? 'text' : 'password'" formControlName="pin" placeholder="PIN de firma"
        maxlength="4" autocomplete="off" (keypress)="validarNumeroPin($event)">

      <button mat-icon-button matSuffix (click)="togglePinVisibility()"
        [attr.aria-label]="showPin ? 'Ocultar PIN' : 'Mostrar PIN'" [attr.aria-pressed]="showPin">
        <mat-icon>{{ showPin ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>

      @if (pinForm.get('pin')?.invalid && pinForm.get('pin')?.touched) {
        <mat-error>
          @if (pinForm.get('pin')?.errors?.['required']) {
            <span>El PIN es obligatorio.</span>
          }
          @if (pinForm.get('pin')?.errors?.['minlength'] || pinForm.get('pin')?.errors?.['maxlength']) {
            <span>
              El PIN debe tener 4 dígitos.
            </span>
          }
        </mat-error>
      }
    </mat-form-field>

  </form>


  <div class="btn-container">
    <button mat-stroked-button type="button" class="secondary-button"
    (click)="stepper_cuentas = 3; clave_unica = 3;">Volver</button>
    <button mat-stroked-button type="button" class="primary-button" [disabled]="!pinForm.valid"
      (click)="stepper_cuentas = 3; clave_unica = 5;">
      Continuar
    </button>
  </div>

  <div class="container-info-geo" style="padding: 0;">
    Descubre&nbsp;<span (click)="open_modal_info(15)">por qué es necesario crear</span>&nbsp;el PIN y&nbsp;<span
  (click)="open_modal_info(16)">cómo puedes protegerlo.</span>
</div>




</mat-card-content>
</mat-card>

</div>
} @if (clave_unica == 5) {
<div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn">
  <mat-card class="card-simpli">
    <mat-card-content>
      <div class="titulo-simpli">firma la documentación legal y comienza a operar</div>

      <div class="documentos-scroll-container">
        <div class="scroll-content">
          @for (section of ['Documentos legales', 'Poderes legales', 'Contrato']; track section) {
            @if (shouldShowSection(section)) {
              <div class="titulo-simpli-doc" style="font-size: 22px !important;">{{section}}</div>
              <ul style="margin-top: 0px !important; margin-bottom: 0px !important;">
                @for (doc of getDocumentsBySection(section); track doc) {
                  <li>
                    {{document_config[doc].displayName}}
                  </li>
                }
              </ul>
            }
          }
        </div>
      </div>


      <div class="numeroDocumento-footer">
        Selecciona “Firmar documentación” para <strong>firmar todos los documentos</strong> al instante y
        <strong>podrás retomar la</strong>&nbsp;<span (click)="open_modal_info(17)">operación de
      factoring</span>&nbsp;que tienes pendiente.
    </div>

    <div class="btn-container">
      <button mat-stroked-button type="button" class="secondary-button"
      (click)="stepper_cuentas = 3; clave_unica = 4;">Volver</button>
      <button mat-stroked-button type="button" class="primary-button" (click)="step = 6;">
        Firmar documentación
      </button>
    </div>

  </mat-card-content>
</mat-card>
</div>

}
}

<div class="col-lg-3 col-md-2 col-sm-1 col-xs-12 animate__animated animate__faster animate__fadeIn"></div>
}





<!--TEEUD-->
@if(step == 0){


  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

    <div class="title-container" style="text-align: center;">
      <h1 class="titulo-simpli">Necesitamos que subas unos documentos</h1>
      <small class="subtitulo-simpli">Puedes arrastrar o dar click en la zona correspondiente para subir cada tipo de
      documento</small>
    </div>

    <div>

      <div class="container-img-files"><img src="../../../assets/iconografia/adjuntar documentacion simulacion.png">
      </div>

      <div class="upload-container">

        <div class="dropzone" [class.dragover]="isDragOver1" (dragover)="onDragOver($event, 1)"
          (dragleave)="onDragLeave(1)" (drop)="onFileDrop($event, 1)" (click)="triggerFileInput(1)">

          @if (!uploadedFile1) {
            <p>Constitución de la sociedad</p>
          }
          @if (uploadedFile1) {
            <p>{{ uploadedFile1.name }}</p>
          }

          <input type="file" id="fileInput1" hidden (change)="onFileSelect($event, 1)" />

        </div>

        <div class="dropzone" [class.dragover]="isDragOver2" (dragover)="onDragOver($event, 2)"
          (dragleave)="onDragLeave(2)" (drop)="onFileDrop($event, 2)" (click)="triggerFileInput(2)">
          @if (!uploadedFile2) {
            <p>Inscripción en el conservador de bienes raíces</p>
          }
          @if (uploadedFile2) {
            <p>{{ uploadedFile2.name }}</p>
          }
          <input type="file" id="fileInput2" hidden (change)="onFileSelect($event, 2)" />
        </div>

      </div>

      <div class="btn-container" style="margin-top: 40px;">
        <button mat-stroked-button type="button" class="secondary-button" (click)="step = 2">Volver</button>
        <button mat-stroked-button [disabled]="uploadedFile1 == null || uploadedFile2 == null" type="button"
        class="primary-button" (click)="subir_archivos()">Subir documentos</button>
      </div>

    </div>

  </div>

}

@if(step == 6){
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn container-rosa">
    <div class="container-step6-resp">
      <div class="imagen-final">
        <img src="../../assets/iconografia/Ceder facturas a simpli.png" style="height: 160px !important;">
      </div>

      <div class="text-step6">
        <div class="titulo-card">¡Todo listo [Primer Nombre cliente]! <br>
        ya puedes retomar la operación que tienes pendiente</div>
        <div class="subtitulo-card"><strong>Cédenos tus</strong>&nbsp;<span (click)="open_modal_info(18)">facturas
      preaprobadas</span>&nbsp;ahora y comenzaremos a gestionar el <strong>financiamiento para tu
    empresa.</strong>
  </div>

  <div class="btn-container" style="margin-top: 40px; display: flex; flex-direction: column;">
    <button mat-stroked-button type="button" class="primary-button" (click)="step = 7">Ceder facturas a
    Simpli</button>
    <button mat-stroked-button type="button" class="secondary-button" style="margin-top: 20px;">Descargar
    documentos firmados</button>
  </div>
</div>



</div>
</div>

<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn container-blanco">
  <div class="container-step6">
    <div class="titulo-card">resumen de tu primera operación en Simpli</div>

    <div class="box-info-onboarding">
      <div class="icon"><span class="material-symbols-outlined">info</span></div>
      <div>La apertura de la linea de factoring tiene un costo aproximado de $98.500, que se descontará de la primera
        operación.
      </div>
    </div>

    <div class="box-info-facturas">
      <div class="titulo-facturas">Facturas de la simulación</div>

      <div class="container-facturas add_factoring">

        <div class="row" style="margin-bottom: 5px;">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Cantidad de facturas:</div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="font-weight: bold;text-align: right;">
            @if(loading_cantidad){
              <skeleton-loader></skeleton-loader>
              }@else{
              {{cantidad_facturas}}
            }
          </div>

        </div>

        <div>
          <div style="text-align: right;">
            <mat-label class="pink-label" (click)="detalle_factura()">Abrir detalle <span class="material-symbols-outlined">chevron_right</span></mat-label>
          </div>
        </div>

      </div>
    </div>

    <div class="box-info-facturas">
      <div class="titulo-facturas">Montos asociados</div>

      <div>
        <div class="row row-montos">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total simulado:</div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
            @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              ${{settings.formatMoney(monto_simulado)}}
            }
          </div>
        </div>
        <div class="row row-montos">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Porcentaje de financiamiento:</div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
            @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              {{porcentaje_financiamiento}}%
            }
          </div>
        </div>
        <div class="row row-montos">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto de anticipo:</div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
            @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              ${{settings.formatMoney(monto_anticipo)}}
            }
          </div>
        </div>
        <div class="row row-montos">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Vencimiento:</div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
            @if(loading){
              <skeleton-loader></skeleton-loader>
              }@else{
              {{dias_promedio}} días
            }
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

}

<!-- Ceder facturas a Simpli-->
@if(step == 7) {
  <div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 animate__animated animate__faster animate__fadeIn"
  style="height: 100vh; background: var(--simpli-cuarteto);"></div>
  <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn"
    style="height: 100vh; background: var(--simpli-cuarteto) !important;">
    <mat-card class="card-simpli">
      <mat-card-content>
        <div class="titulo-simpli">elige el método para cedernos tus facturas</div>
        <div class="texto-centrado">Necesitamos que nos cedas tus facturas para comenzar a gestionar tu financiamiento.
        </div>

        <div class="container-step7">
          <div class="step7">

            <div class="cajas">
              <div class="caja-rosa">
                <img src="../../assets/img/Logo.png">
                <div class="text">Ceder por la plataforma para clientes</div>
              </div>
              <div class="modal">
                <span class="material-symbols-outlined">error</span><span (click)="open_modal_info(19)">¿Qué significa ceder
              por la plataforma para clientes?</span>
            </div>
          </div>

          <div class="cajas">
            <div class="caja-rosa">
              <img src="../../assets/img/Logo.png">
              <div class="text">Ceder por un sistema externo</div>
            </div>
            <div class="modal">
              <span class="material-symbols-outlined">error</span><span (click)="open_modal_info(20)">¿Qué significa ceder
            por un sistema externo?</span>
          </div>
        </div>

        <div class="cajas">
          <div class="caja-rosa">
            <img src="../../assets/img/Logo.png">
            <div class="text">Ceder por AEC</div>
          </div>
          <div class="modal">
            <span class="material-symbols-outlined">error</span><span (click)="open_modal_info(21)">¿Qué significa ceder
          por AEC?</span>
        </div>
      </div>

    </div>
  </div>

</mat-card-content>
</mat-card>
</div>
<div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 animate__animated animate__faster animate__fadeIn"
style="height: 100vh; background: var(--simpli-cuarteto);"></div>
}

@if(step == 7) {
  <div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 animate__animated animate__faster animate__fadeIn"
  style="height: 100vh; background: var(--simpli-cuarteto);"></div>
  <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 animate__animated animate__faster animate__fadeIn"
    style="height: 100vh; background: var(--simpli-cuarteto) !important;">
    <mat-card class="card-simpli">
      <mat-card-content>
        <div class="titulo-simpli">elige el método para cedernos tus facturas</div>
        <div class="texto-centrado">Necesitamos que nos cedas tus facturas para comenzar a gestionar tu financiamiento.
        </div>

        <div class="container-step7">
          <div class="step7">

            <div class="cajas">
              <div class="caja-rosa">
                <img src="../../assets/img/Logo.png">
                <div class="text">Ceder por la plataforma para clientes</div>
              </div>
              <div class="modal">
                <span class="material-symbols-outlined">error</span><span (click)="open_modal_info(19)">¿Qué significa ceder
              por la plataforma para clientes?</span>
            </div>
          </div>

          <div class="cajas">
            <div class="caja-rosa">
              <img src="../../assets/img/Logo.png">
              <div class="text">Ceder por un sistema externo</div>
            </div>
            <div class="modal">
              <span class="material-symbols-outlined">error</span><span (click)="open_modal_info(20)">¿Qué significa ceder
            por un sistema externo?</span>
          </div>
        </div>

        <div class="cajas">
          <div class="caja-rosa">
            <img src="../../assets/img/Logo.png">
            <div class="text">Ceder por AEC</div>
          </div>
          <div class="modal">
            <span class="material-symbols-outlined">error</span><span (click)="open_modal_info(21)">¿Qué significa ceder
          por AEC?</span>
        </div>
      </div>

    </div>
  </div>

</mat-card-content>
</mat-card>
</div>
<div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 animate__animated animate__faster animate__fadeIn"
style="height: 100vh; background: var(--simpli-cuarteto);"></div>
}

</div>

@if (step == 8){
  <app-carga-documentacion [initialStep]="documentacionStep"
  [esEmpresaEnUnDia]="esEmpresaEnUnDia"></app-carga-documentacion>
}

@if (step == 9) {
  <app-revision-contrato [initialStep]="revisionStep"></app-revision-contrato>
}

<!-- Step 13: Crear simulacion -->
@if (step == 10) {
  @if(simulacion == 0){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step-4"
      style="position: relative;">

      <mat-card class="centerabsolute-3 step-4">
        <mat-card-content>

          <div class="container-final">
            <div class="container-titulos">
              <div class="label-negro">¡Felicidades {{business_name}}!</div>
              <div class="imagen-final-resp">
                <img src="../../assets/iconografia/basurero.svg">
              </div>
              <div class="label-azul" style="color: var(--simpli-tertiary) !important;">Ya puedes financiarte con nosotros
              </div>
              <div class="label-container" style="text-align: center !important;">Haz una <span
              (click)="open_modal_info(31)">simulación de factoring</span> ahora y solicita tu primer financiamiento.
            </div>

            <div class="caja-botones">
              <button mat-stroked-button class="primary-button" (click)="simulacion = 1;">Iniciar simulación</button>
            </div>
          </div>
          <div class="imagen-final">
            <img src="../../assets/iconografia/basurero.svg">
          </div>
        </div>

        <div class="contact-componente">
          <contact-container [tittle]="'Si tienes preguntas, puedes contactar a un ejecutivo.'"></contact-container>
        </div>

      </mat-card-content>
    </mat-card>

    <div class="row">

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-pink">




      </div>

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-white">




      </div>

    </div>

  </div>
}

@if(simulacion == 1){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn"
    style="margin-top: 5%;">


    <mat-card class="centerabsolute" style="max-width: 600px;">

      <mat-card-content>
        <div class="titulo-card">
          agrega las facturas para generar tu simulación de factoring
        </div>

        <div class="imagen-final">
          <img src="../../assets/iconografia/Iconografia - Development(3).png" style="height: 160px !important;">
        </div>

        <div class="footer-botones">
          <span (click)="open_modal_info(31)">¿Qué es una simulación de factoring?</span>
        </div>

        <div class="caja-botones mt-20">

          <!-- <button mat-stroked-button class="primary-button" (click)="open_agregar_facturas()">Agregar una factura</button> -->
          <button mat-stroked-button class="primary-button" (click)="open_modal_info(11)">Agregar facturas</button>
          <button mat-stroked-button class="secondary-button" (click)="open_agregar_facturas_by_nomina()">Cargar nómina de
          facturas</button>
        </div>

      </mat-card-content>

    </mat-card>



  </div>
}

@if(simulacion == 2){
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <div style="margin-top: 30px;">

      <!-- Stepper para onboarding -->
      <div class="stepper">
        <div id="step-simpli1-onboarding" class="stepper-simpli stepper-simpli-active">
          <span class="material-symbols-outlined">edit</span>
          <div class="step-text">Vencimiento</div>
          <div class="line-step-simpli"></div>
        </div>

        <div id="step-simpli2-onboarding" class="stepper-simpli">
          <span class="material-symbols-outlined">note</span>
          <div class="step-text">Resumen</div>
        </div>
      </div>

      <div class="titulo-card" style="margin-bottom: 10px; margin-top: 0 !important;">asigna el porcentaje de
        financiamiento y tipo de vencimiento
      </div>

    </div>
  </div>

  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">
    <mat-card class="centerabsolute" [style.max-width]="cardMaxWidth">
      <mat-card-content>
        @if (comenzar_simulacion) {
          <div>
            <div class="col-lg-12 col-md-12 col-xs-12 col-top">
              <app-start-simulation [fromOnboarding]="true" [facturas]="facturas" [simulationData]="simulationData"
                [postFinalData]="postFinalData" [currentStepFromParent]="currentStepOnboarding"
                (volverOnboarding)="volver_desde_start_simulation()" (stepChanged)="onStepChanged($event)"
                (simulationCompleted)="onSimulationCompleted($event)" (editSimulation)="onEditSimulation($event)"
                (cardWidthChange)="onCardWidthChange($event)" (stepStateChanged)="onStepStateChangedOnboarding($event)">
              </app-start-simulation>
            </div>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
}

}